import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Accordion, LinkButton } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import { UpArrow } from '../assets/images';
import * as actions from '../routes/actions/Account';
import * as studyActions from '../routes/actions/Study';
import * as productActions from '../routes/actions/Product';
import { slugify } from '../helpers';
import { footerIcons } from '../services/constants';
import { taxonomies } from '../variables/General';

// const tempContracts = [
//   {
//     domainId: 1,
//     domainName: "Doğru Kaynak B2C",
//     contractId: 41,
//     name: "Aydınlatma Metni",
//     contract: "",
//     contractTypeId: 7,
//     contractTypeName: "KVKK Aydınlatma Metni",
//     domainContractsId: 46,
//     contractVersion: 6,
//     contractKeys: [],
//     content: "",
//     contractsUserId: 0,
//     places: ["Footer", "SignupInfo"],
//     isMandatory: 0,
//     isWarning: false,
//   },
//   {
//     domainId: 1,
//     domainName: "Doğru Kaynak B2C",
//     contractId: 66,
//     name: "Gizlilik Politikası",
//     contract: "",
//     contractTypeId: 3,
//     contractTypeName: "Gizlilik Politikası",
//     domainContractsId: 80,
//     contractVersion: 6,
//     contractKeys: [],
//     content: "",
//     contractsUserId: 0,
//     places: ["Footer", "Signup"],
//     isMandatory: 0,
//     isWarning: false,
//   },
//   {
//     domainId: 1,
//     domainName: "Doğru Kaynak B2C",
//     contractId: 39,
//     name: "Üyelik Sözleşmesi",
//     contract: "",
//     contractTypeId: 1,
//     contractTypeName: "Üyelik Sözleşmesi",
//     domainContractsId: 43,
//     contractVersion: 2,
//     contractKeys: [],
//     content: "",
//     contractsUserId: 0,
//     places: ["Footer", "Signup"],
//     isMandatory: 0,
//     isWarning: false,
//   },
//   {
//     domainId: 1,
//     domainName: "Doğru Kaynak B2C",
//     contractId: 3,
//     name: "Mesafeli Satış Sözleşmesi",
//     contract: "",
//     contractTypeId: 2,
//     contractTypeName: "Mesafeli Satış Sözleşmesi",
//     domainContractsId: 3,
//     contractVersion: 1,
//     contractKeys: [],
//     content: "",
//     contractsUserId: 0,
//     places: ["Footer"],
//     isMandatory: 0,
//     isWarning: false,
//   },
//   {
//     domainId: 1,
//     domainName: "Doğru Kaynak B2C",
//     contractId: 8,
//     name: "Çerez Politikası",
//     contract: "",
//     contractTypeId: 4,
//     contractTypeName: "Çerez Politikası",
//     domainContractsId: 10,
//     contractVersion: 1,
//     contractKeys: [],
//     content: "",
//     contractsUserId: 0,
//     places: ["Footer", "Signup"],
//     isMandatory: 0,
//     isWarning: false,
//   },
// ];

const FooterItems = ({ contracts, footerIcons }) => (
  <div className="footer-items col-md-12 flex-wrap">
    <div className="d-flex flex-column col-md-3">
      <Link className="btn-link text-left" to="/satis-noktalarimiz">
        <img src={require('../assets/images/footer/icon-maps.svg')} alt="" />
        <div className="footer-link-item">Tonguç Hangi Kırtasiyede?</div>
      </Link>
      <Link to="/iletisim" className="btn-link text-left">
        <img
          src={require('../assets/images/footer/icon-call-center.svg')}
          alt=""
        />

        <div className="footer-link-item">İletişim</div>
      </Link>
      <Link to="/biz-kimiz" className="btn-link text-left">
        <img src={require('../assets/images/footer/icon-info.svg')} alt="" />

        <div className="footer-link-item">Hakkımızda</div>
      </Link>
      <a
        className="btn-link text-left"
        href="https://b2b.dogrukaynak.com/"
        target="_blank"
      >
        <img src={require('../assets/images/footer/icon-login.svg')} alt="" />

        <div className="footer-link-item">Kırtasiye girişi</div>
      </a>
    </div>

    <div className="d-flex flex-column col-md-3">
      {contracts &&
        contracts.map((contract, i) => {
          return (
            <Link
              key={i}
              className="footer-link-item btn-link"
              to={`/sozlesmeler/${slugify(
                contract.contractName + ' ' + contract.contractTypeId,
              )}`}
            >
              {contract.contractName}
            </Link>
          );
        })}
    </div>

    <div className="d-flex flex-column col-md-3">
      <Link className="footer-link-item btn-link" to={`/hesabim/yardim`}>
        Sıkça Sorulan Sorular
      </Link>
      <Link
        className="footer-link-item btn-link"
        to={'/hesabim/yardim#siparis-bilgi'}
      >
        Yardım
      </Link>
    </div>

    <div className="d-flex flex-column mt-lg-0 col-md-3">
      <div className="footer-app-download">
        <div className="footer-app-item">
          <a
            href="https://play.google.com/store/apps/details?id=com.tonguc.doktor&hl=tr"
            target="_blank"
          >
            <img
              className="img-fluid"
              src={require('../assets/images/footer/google-play.png')}
              alt=""
            />
          </a>
        </div>
        <div className="footer-app-item">
          <a
            href="https://apps.apple.com/tr/app/tats/id1233987029?l=tr  "
            target="_blank"
          >
            <img
              className="img-fluid custom-img"
              src={require('../assets/images/footer/app-store.png')}
              alt=""
            />
          </a>
        </div>
        <div className="footer-app-item">
          <img
            className="img-fluid"
            src={require('../assets/images/footer/ssl.png')}
            alt="SSL Sertifikası"
          />
        </div>
      </div>
    </div>
  </div>
);

const FooterItems2 = ({ taxonomies }) => {
  let taxnew = [
    [
      taxonomies.find((x) => x.code === 'kitap-serileri'),
      taxonomies.find((x) => x.code === 'sinavlar'),
    ],
    taxonomies.find((x) => x.code === 'siniflar'),
    [
      taxonomies.find((x) => x.code === 'urun-tipi'),
      taxonomies.find((x) => x.code === 'one-cikanlar'),
    ],
    taxonomies.find((x) => x.code === 'dersler'),
  ];
  return (
    taxonomies.length > 0 && (
      <div className="footer-items col-md-12">
        {taxnew &&
          taxnew.map((item, i) => {
            return item.length > 0 ? (
              <div className="d-flex flex-column col-md-3">
                {item.map(
                  (tax, j) =>
                    tax && (
                      <div
                        className="d-flex flex-column"
                        style={{ marginTop: j === 0 ? '0px' : '10px' }}
                      >
                        <h6> {tax.name} </h6>
                        {tax.taxons.map((taxon) =>
                          taxon.count > 0 ? (
                            <Link
                              className="btn-link text-left"
                              style={{ padding: '0px' }}
                              to={`/urunler?t=${taxon.id}`}
                            >
                              <div className="footer-link-item">
                                {taxon.name}
                              </div>
                            </Link>
                          ) : null,
                        )}
                      </div>
                    ),
                )}
              </div>
            ) : (
              <div className="d-flex flex-column col-md-3">
                <h6> {item.name}</h6>
                {item.taxons.map((taxon) =>
                  taxon.count > 0 ? (
                    <Link
                      className="btn-link text-left"
                      style={{ padding: '0px' }}
                      to={`/urunler?t=${taxon.id}`}
                    >
                      <div className="footer-link-item">{taxon.name}</div>
                    </Link>
                  ) : null,
                )}
              </div>
            );
          })}
      </div>
    )
  );
};
const ChangeMode = ({ light, logoutDemoUser, history, user }) => {
  return (
    <button
      onClick={() => {
        if (user.id && user.demo) {
          logoutDemoUser();
        }
        history.push('/');
      }}
      className="btn-link p-2 nav-link d-block"
    >
      <FontAwesomeIcon icon={faLongArrowAltLeft} className="mr-1" />
      <strong>{!light ? 'Mağaza Moduna Dön' : "Mağaza'ya dön"}</strong>
    </button>
  );
};

class Footer extends Component {
  scrollFunction() {
    if (
      document.body.scrollTop > window.innerHeight ||
      document.documentElement.scrollTop > window.innerHeight
    ) {
      document.getElementById('scrollTopBtn').style.opacity = 1;
    } else {
      const btn = document.getElementById('scrollTopBtn');

      if (btn) {
        btn.style.opacity = 0;
      }
    }
  }

  componentDidMount() {
    if (
      this.props.contracts.length === 0 &&
      this.props.location.pathname.indexOf('/odeme/') === -1
    )
      this.props.getContractsNoContent();

    if (this.props.activityTypes.length === 0) {
      this.props.getActivityTypes();
    }
    this.props.getFooterTaxonomies();
  }

  render() {
    const { taxonomiesFooter, contracts } = this.props;

    let contractsArray = contracts || [];

    let footerContracts = contractsArray.filter(
      (c) => c.places && c.places.indexOf('Footer') > -1,
    );

    let filteredTaxonomies = taxonomiesFooter.filter((taxonomy) => {
      return taxonomy.code !== 'soru';
    });
    this.scrollFunction();

    window.onscroll = () => {
      this.scrollFunction();
    };

    // const root = taxonomies.find((t) => t.code === "siniflar");
    // const classRooms = root ? root.taxons : [];

    // const rootExams = taxonomies.find((t) => t.code === "sinavlar");
    // const exams = rootExams ? rootExams.taxons : [];
    return (
      <footer>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-between p-0">
                  <div
                    className="scrollTopBtn"
                    id="scrollTopBtn"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <UpArrow />
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {this.props.light && !this.props.isPaymentPage && (
          <div className="container-fluid">
            <div className="container p-0">
              <Accordion
                contracts={footerContracts}
                taxonomies={filteredTaxonomies}
              />
            </div>
          </div>
        )}

        {/*
        <div className="container-fluid bg-gray" style={{ borderBottom: "2px solid #fff" }}>
          <div className="row">
            <div className="col-12 col-md-7 py-3 ml-auto mr-auto d-flex flex-column flex-xl-row">
              <p className="flex-1 fs-13  font-weight-600">
                Doğru Kaynak fırsatları, kampanya ve duyuruları ile ilgili e-posta almak ister misiniz?
            </p>

              <form className="flex-1">
                <div className="input-container">
                  <input type="text" className="form-control" />
                  <button className="btn btn-primary">
                    Kayıt Ol
                </button>
                </div>
              </form>
            </div>
          </div>
        </div>
         */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* Check Dark7Light and Render footer */}

              <div className="container kategoriler-bottom">
                {this.props.light && !this.props.isPaymentPage ? (
                  <FooterItems2 taxonomies={filteredTaxonomies} />
                ) : // <ChangeMode
                //   light={this.props.light}
                //   logoutDemoUser={this.props.logoutDemoUser}
                //   history={this.props.history}
                //   user={this.props.user}
                // />
                null}
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* Check Dark7Light and Render footer */}
              <div className="container">
                {this.props.light && !this.props.isPaymentPage ? (
                  <FooterItems
                    footerIcons={footerIcons}
                    contracts={footerContracts}
                  />
                ) : // <ChangeMode
                //   light={this.props.light}
                //   logoutDemoUser={this.props.logoutDemoUser}
                //   history={this.props.history}
                //   user={this.props.user}
                // />
                null}
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="col-md-12 text-center tgcWorksContain">
            <div class="tongucworks">
              <a class="pe-2 tgcMagaza" href="https://tongucmagaza.com/">
                <img
                  src={require('../assets/images/footer/TM_renkli-logo.png')}
                  alt="tonguçMAĞAZA Logo"
                  class="img-fluid"
                />
              </a>{' '}
              bir{' '}
              <a
                class="px-2 tgcWorks"
                href="https://tongucworks.com/"
                target="_blank"
              >
                <img
                  class="img-fluid"
                  src={require('../assets/images/footer/TW_renkli-logo.png')}
                  alt="tonguçWORKS Logo"
                />
              </a>{' '}
              kuruluşudur.
            </div>
            <div class="copyRight">Copyright © 2023 Tüm Hakları Saklıdır.</div>
            <div id="ETBIS">
              <div id="3831211045078072">
                <a
                  href="https://etbis.eticaret.gov.tr/sitedogrulama/3831211045078072"
                  target="_blank"
                >
                  <img
                    height="90"
                    width="75"
                    src="data:image/jpeg;base64,
                      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"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  light: PropTypes.bool,
  isPaymentPage: PropTypes.bool,
};

const mapStateToProps = ({ ProductReducer, AccountReducer, StudyReducer }) => ({
  taxonomies: ProductReducer.taxonomies,
  taxonomiesFooter: ProductReducer.taxonomiesFooter,
  contracts: AccountReducer.contractsNoContent,
  activityTypes: StudyReducer.activityTypes,
  user: AccountReducer.user,
});
const mapDispatchToProps = {
  getContracts: actions.getContracts,
  getContractsNoContent: actions.getContractsNoContent,
  getActivityTypes: studyActions.getActivityTypes,
  logoutDemoUser: actions.logoutDemoUser,
  getFooterTaxonomies: productActions.getFooterTaxonomies,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer));
